import { Grid, IconButton } from "@mui/material";
import CloseIcon from "assets/CloseIcon";

interface Props {
  handleClose: () => void;
}

function CloseButton(props: Props) {
  const { handleClose } = props;

  return (
    <Grid container display="flex" spacing={2}>
      <Grid item xs={12} display="flex" justifyContent="flex-end">
        <IconButton onClick={handleClose}>
          {" "}
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default CloseButton;
